export default {
    // core-ui
    sidebarShow: 'responsive',
    sidebarMinimize: false,

    user: {},
    config: {},
    alerts: [],
};
